// Define the filter function for filtering by the first character
export const filterByFirstCharacter = (rows, columnId, filterValue) => {
  return rows.filter((row) => {
    const rowValue = row.values[columnId]
    return rowValue.startsWith(filterValue)
  })
}
